// @flow

import { connect } from 'react-redux';
import Schedule from './schedule';

export type Props = {
  user: User,
};

const mapState = ({ authentication }) => ({
  user: authentication.user,
});

export default connect(
  mapState,
)(Schedule);
